export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-03-20 at 8.53.55 PM.a59b5ded.jpeg";